<kendo-appbar position="top">
    <kendo-appbar-section>
        <img width="180" height="50" src="../../../assets/img/logo-cloudFlow-whiteBg-20231114-110848.svg" class="img-fluid" />
    </kendo-appbar-section>

    <kendo-appbar-section
        *ngIf="
            authenticationService.isAuthenticated && !(authenticationService.isQrSignatureRoute || authenticationService.isFunctionalUser)
        ">
        <ul>
            <li
                *ngFor="let item of menuItems.parents"
                class="page-link"
                [ngClass]="{ selected: isRouteSelected(item) }"
                (click)="onRoute(item)">
                {{ item.translation | translate }}
            </li>
        </ul>
    </kendo-appbar-section>

    <kendo-appbar-spacer></kendo-appbar-spacer>

    <kendo-appbar-section
        *ngIf="
            authenticationService.isAuthenticated && !(authenticationService.isQrSignatureRoute || authenticationService.isFunctionalUser)
        ">
        <label> <i class="fas fa-user"></i> : {{ loggedUserName }} </label>
    </kendo-appbar-section>

    <kendo-appbar-spacer width="10px"></kendo-appbar-spacer>

    <kendo-appbar-spacer width="10px"></kendo-appbar-spacer>
    <kendo-appbar-section class="actions">
        <kendo-dropdownlist
            [data]="languages"
            textField="text"
            valueField="localeId"
            [value]="selectedLanguage"
            (valueChange)="changeLanguage($event)"
            style="width: 150px">
            <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
                <i class="k-icon {{ dataItem.icon }}"></i>&nbsp;<label>{{ dataItem.text | translate }}</label>
            </ng-template>
        </kendo-dropdownlist>

        <kendo-appbar-spacer width="20px"></kendo-appbar-spacer>

        <div
            *ngIf="
                authenticationService.isAuthenticated &&
                !(authenticationService.isQrSignatureRoute || authenticationService.isFunctionalUser)
            ">
            <button kendoButton (click)="onLogout()">
                <span class="k-icon k-i-logout"></span>
                <span> {{ 'navbar.logout' | translate }} </span>
            </button>
        </div>
    </kendo-appbar-section>
</kendo-appbar>
